export const BROWSER_CHROME = "Chrome";
export const BROWSER_FIREFOX = "Firefox";
export const BROWSER_EDGE = "Edge";
export const BROWSER_SAFARI = "Safari";
export const BROWSER_OPERA = "Opera";
export const BROWSER_UNKNOWN = "Unknown";

export type BrowserName =
  | typeof BROWSER_CHROME
  | typeof BROWSER_FIREFOX
  | typeof BROWSER_EDGE
  | typeof BROWSER_SAFARI
  | typeof BROWSER_OPERA
  | typeof BROWSER_UNKNOWN;

// Detect current browser
export const getCurrentBrowser = (): BrowserName => {
  const userAgent = navigator.userAgent;
  if (userAgent.includes("Chrome") && !userAgent.includes("Edg") && !userAgent.includes("OPR")) {
    return BROWSER_CHROME;
  } else if (userAgent.includes("Firefox")) {
    return BROWSER_FIREFOX;
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    return BROWSER_SAFARI;
  } else if (userAgent.includes("Edg")) {
    return BROWSER_EDGE;
  } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
    return BROWSER_OPERA;
  } else {
    return BROWSER_UNKNOWN;
  }
};

export const checkIfWindows = (): boolean => {
  return navigator.platform.toLowerCase().startsWith("win");
};
